import * as React from 'react';

import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

export const NounNews: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style} viewBox="0 0 100 100">
        <path d="M64,19.42V70.24a2.63,2.63,0,0,1-3.93,2.28c-14.16-11-27.94-12.45-27.94-12.45,0,2,0,3.89.16,5.82.12,1.61.8,5.91,1.3,8.25.92,4.31-2.36,8.3-7,9.09-.32,0-.64.09-1,.11a7.22,7.22,0,0,1-8.13-7,7.69,7.69,0,0,1,0-1c.17-2.38,7.64-17.42-2.31-19.09q-4.11-.6-8.32-.92a2.62,2.62,0,0,1-2.43-2.62V36.94a2.62,2.62,0,0,1,2.49-2.62c8.44-.45,41.31-6.09,53.12-17.17C61.54,15.76,64,17.38,64,19.42Z" />
        <path d="M14.08,56.09V33.65" />
        <line x1="76.29" y1="43.95" x2="95.56" y2="43.95" />
        <line x1="71.84" y1="31.42" x2="85.39" y2="17.86" />
        <line x1="71.84" y1="57.83" x2="85.46" y2="71.45" />
    </SVGWrapper>
);
